var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProtectedRoute } from '@src/app/helper';
import { Route, Routes, Outlet } from 'react-router-dom';
import NoScheduleIndex from './NoSchedule/NoSchedule';
import WithScheduleIndex from './WithSchedule/WithSchedule';
import LateUploadIndex from './LateUpload/LateUpload';
import DoneUploadIndex from './DoneUpload/DoneUpload';
import DoneUploadWithoutProofIndex from './DoneUploadWithoutProof/DoneUploadWithoutProof';
var SchedulePage = function () {
    return (_jsx(Routes, { children: _jsxs(Route, __assign({ element: _jsx(Outlet, {}) }, { children: [_jsx(Route, { path: '/no-schedule', element: _jsx(ProtectedRoute, { permission: 'nojadwal.view', children: _jsx(NoScheduleIndex, {}) }) }), _jsx(Route, { path: '/with-schedule', element: _jsx(ProtectedRoute, { permission: 'jadwal.view', children: _jsx(WithScheduleIndex, {}) }) }), _jsx(Route, { path: '/late-upload', element: _jsx(ProtectedRoute, { permission: 'jadwal.view', children: _jsx(LateUploadIndex, {}) }) }), _jsx(Route, { path: '/done-upload', element: _jsx(ProtectedRoute, { permission: 'jadwal.view', children: _jsx(DoneUploadIndex, {}) }) }), _jsx(Route, { path: '/no-link-done-upload', element: _jsx(ProtectedRoute, { permission: 'jadwal.view', children: _jsx(DoneUploadWithoutProofIndex, {}) }) })] })) }));
};
export default SchedulePage;
